document.addEventListener("DOMContentLoaded", function() {
    (function ($) {
        app.loadMore = {
            init: function () {
                let $loadMoreHandler = $('.load-more-container');
                let $loadMoreBody;
                if($('.tiles-grid__sidebar').length) {
                    $loadMoreBody = $loadMoreHandler.find('.tiles-grid__sidebar');
                } else {
                    $loadMoreBody = $loadMoreHandler.find('.load-more-body');
                }

                $loadMoreHandler.on('load-more.run', function (e, data) {
                    reset = (data['reset'] !== undefined) ? data['reset'] : false;

                    let $loadMoreBtn = $loadMoreHandler.find(app.loadMore.buttonSelector);
                    let page = data['paged'];

                    // // Prevent multiple clicks at a time
                    if ($loadMoreHandler.data('loading')) {
                        return;
                    }

                    $loadMoreHandler.data('loading', true);

                    // If resetting, then make sure to empty the container of existing items
                    if (reset) {
                        $loadMoreBody.html(app.loadMore.loader);
                        page = 1;
                    } else {
                        // Disable button and show loader
                        $loadMoreBtn.addClass('disabled');
                    }

                    let params = $.mergeObjects($loadMoreHandler.data('filters'), {
                        action: 'app_load_more',
                        paged: page,
                        loop: $loadMoreHandler.data('type')
                    });

                    window.axios.get(app.url.ajax, {
                        params: params
                    })
                        .then(function (response) {
                            let urlParams = $.param($loadMoreHandler.data('filters'));

                            window.history.replaceState({"action": "load-more"}, null, urlParams ? '?' + urlParams : '?');

                            if(urlParams) {
                            	$loadMoreHandler.addClass('isFiltered')
                            } else {
                            	$loadMoreHandler.removeClass('isFiltered')
                            }

                            window.scrollTo(0, 0);

                            // Remove loader if resetting or loader button
                            if (reset) {
                                $loadMoreBody.html('');
                            } else {
                                $loadMoreBtn.parent().remove();
                            }

                            // Re-enable filters form
                            if ($($loadMoreHandler.data('form')).length) {
                                $($loadMoreHandler.data('form')).find('fieldset').prop('readonly', false);
                            }

                            // Append results
                            $loadMoreBody.html('');
                            $loadMoreBody.append(response.data);

                            // End loading status
                            $loadMoreHandler.data('loading', false);

                            // Add event trigger for completion
                            $loadMoreHandler.trigger('load-more.complete');
                        });
                });

                $loadMoreHandler.on('click', app.loadMore.buttonSelector, function (e) {
                    e.preventDefault();
                    let page = $(this).data('page');
                    $loadMoreHandler.trigger('load-more.run', [{reset: false, paged: page}]);
                });

                $loadMoreHandler.on('click', app.loadMore.loadMoreNumbered, function (e) {
                    e.preventDefault();
                    let page = $(this).data('page');
                    $loadMoreHandler.trigger('load-more.run', [{reset: false, paged: page}]);
                });

                $($loadMoreHandler.data('form')).on('submit, change', function (e) {
                    e.preventDefault();

                    let $this = $(this);

                    // Prevent multiple clicks at a time
                    if ($loadMoreHandler.data('loading')) {
                        return;
                    }

                    $this.find('fieldset').prop('readonly', true);

                    $loadMoreHandler.data('filters', $this.serializeObject());

                    $loadMoreHandler.trigger('load-more.run', [true]);
                });

                if ($loadMoreHandler.data('form')) {
                    let $form = $($loadMoreHandler.data('form'));
                    $form.on('change', 'select', function (e) {
                        e.preventDefault();
                        $form.submit();
                    });

                    $loadMoreHandler.data('filters', $form.serializeObject());
                }

                /**
                 * Udate the URL with filters using History API
                 */
                window.onpopstate = function (event) {
                    if (event.state.hasOwnProperty('action') && event.state.action === "load-more") {
                        // Run AJAX load more
                        $loadMoreHandler.trigger('load-more.run', [true]);
                    }
                };
            },
            buttonSelector: '.load-more-btn',
            loadMoreNumbered: '.load-more-numbered',
            loader: '<div class="app-loader-container"><div class="app-loader"></div></div>',
        }

        if($('.load-more-container').length) {
            app.loadMore.init();
        }
    })(jQuery);
});
